export default "__VITE_ASSET__D82z3ABH__"